import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Drawer, Stack, useScrollTrigger } from "@mui/material";

import User from "./User";
import Filter from "./Filter";
import { useResponsive } from "../../../../hooks/useResponsive";
import filterIcon from "../../../../styles/svg/epic-icon.svg";
import { useBoards } from "../../../../utils/reactQuery/boards";
import { setActiveBoards } from "../../../../redux/ActiveBoardSlice";
import { useSearchParams } from "react-router-dom";
import "./../../myTask.scss";
import DrawerGlobalComp from "../../../../components/Drawer";

function Header({ currentTab }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useResponsive("down", "md");
  const [filterDrawer, setFilterDrawer] = useState(false);
  const trigger = useScrollTrigger();
  const { boards } = useBoards();
  const dispatch = useDispatch();
  const tab = searchParams.get("tab");

  // Check if filter should be shown (hide when currentTab is "my-planner")
  const shouldShowFilter = currentTab !== "my-planner";

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (tab == "mine") {
      updateSearchParams("tab", "mine");
    }
  }, []);

  useEffect(() => {
    if (boards) {
      dispatch(
        setActiveBoards(
          boards?.data?.data?.responseData
            .filter((el) => !el.is_archive)
            .sort(function (a, b) {
              return a.board_name.localeCompare(b.board_name);
            }) || []
        )
      );
    }
  }, [boards]);

  return (
    <div className="d-flex justify-content-space-between header-container">
      {isMobile ? (
        <div className="user-container">
          <User />
        </div>
      ) : (
        <User />
      )}
      {shouldShowFilter && (
        <>
          {isMobile ? (
            <div>
              <Stack direction="row" justifyContent={"space-between"}>
                <img
                  src={filterIcon}
                  alt="filter"
                  className="filter-icon"
                  onClick={() => setFilterDrawer(true)}
                />
              </Stack>
            </div>
          ) : (
            <div className="d-flex">
              <Filter />
            </div>
          )}

          {filterDrawer && (
            <DrawerGlobalComp
              open={filterDrawer}
              setOpen={setFilterDrawer}
              animatedWidth={330}>
              <Filter setFilterDrawer={()=>setFilterDrawer(false)}/>
            </DrawerGlobalComp>
          )}
        </>
      )}
    </div>
  );
}

export default Header;
